/*eslint-disable*/
import React from "react";
// import { createBrowserHistory } from "history";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "assets/scss/material-kit-react.scss?v=1.9.0";
import "assets/scss/now-ui-dashboard.scss";
import { Provider } from "react-redux";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

//General
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AboutUs from "./views/AboutUs";
import AuthLoading from "./views/AuthLoading";
import RegisterPage from "./views/RegisterPage";
import ManageAdmins from "views/Staff/ManageAdmins.js";
import Dashboard from "views/Dashboard.js";
import { store, FirebaseProvider } from "common";
import { features } from "config";
import ResponsiveDrawer from "./components/ResponsiveDrawer";
// var hist = createBrowserHistory();
// ///////////////////////////////////////////
// API STAFF
import AddStaffAdmin from "views/Staff/AddStaffAdmin.js";
import StaffEditProfile from "views/Staff/StaffEditProfile.js";
import AreaManagement from "views/Staff/AreaManagement.js";
import RegionManagement from "views/Staff/RegionManagement.js";
import BrokerAreaManagement from "views/Staff/BrokerAreaManagement.js";
import AreaInfo from "views/Staff/AreaInfo.js";
import RegionInfo from "views/Staff/RegionInfo.js";
import StaffEnquiries from "views/Staff/StaffEnquiries.js";
import StaffProfile from "views/Staff/StaffProfile.js";
import CreateBranch from "views/Staff/branchManagement.js";
import BranchInformation from "views/Staff/branchInformation.js";
import BranchStatistics from "views/Staff/BranchStatistics.js";
import BrokerProfile from "views/Staff/BrokerProfile.js";
import BranchEnquiries from "views/Staff/BranchEnquiries.js";
import StaffListings from "views/Staff/StaffListings.js";
import AddTenantAdmin from "views/Staff/AddTenantAdmin.js";
import StaffEnquiryInformation from "views/Staff/StaffEnquiryInformation.js";
import AddUserAdmin from "views/Staff/AddUserAdmin.js";
import StaffUpdateWizard from "views/Staff/UpdateWizard/StaffUpdateWizrd.js";
import StaffUpdateEnquiry from "views/Staff/StaffUpdateEnquiry.js"
import StaffDuplicateListing from "views/Staff/StaffDuplicateListing.js"
import StaffPublishWizard from "views/Staff/PublishWizard/StaffPublishWizard.js";
import StaffListingInfomation from "views/Staff/StaffListingInfomation.js";
import StaffPullForwardCalender from "views/Staff/PullForward/StaffPullForwardCalender.js";
import StaffPullForward from "views/Staff/PullForward/StaffPullForward.js";
import StaffPullForwardListing from "views/Staff/PullForward/StaffPullForwardListing.js";
import CreateListing from "views/Staff/createListing.js";
import CreateEnquiry from "views/Staff/createEnquiry.js";
import ManageLandlords from "views/Staff/ManageLandlords.js";
import LeadsNotifications from "views/Staff/Leads/LeadsNotifications.js";
//////////////////////////////////////////////
//  BROKER
import AddTenant from "views/Broker/AddTenant.js";
import BrokerEditProfile from "views/Broker/BrokerEditProfile.js";
import BrokerEnquiries from "views/Broker/BrokerEnquiries.js";
import BrokerListings from "views/Broker/BrokerListings.js";
import BrokerEnquiryInformation from "views/Broker/BrokerEnquiryInformation.js";
//////////////////////////////////////////////
// TENANT

function App() {
  // const navigate = useNavigate();
  return (
    <DndProvider backend={HTML5Backend}>
      <Provider store={store}>
        <FirebaseProvider>
          <AuthLoading>
            <BrowserRouter>
              <Routes>
                {/* API STAFF */}
                <Route
                  path="/stock" //Change path to stock
                  element={
                    <ResponsiveDrawer>
                      <StaffListings />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/areamanagement"
                  element={
                    <ResponsiveDrawer>
                      <AreaManagement />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/regionmanagement"
                  element={
                    <ResponsiveDrawer>
                      <RegionManagement />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/branchEnquiriesStatistics"
                  element={
                    <ResponsiveDrawer>
                      <BranchEnquiries />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/brokerareamanagement"
                  element={
                    <ResponsiveDrawer>
                      <BrokerAreaManagement />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/areainfo"
                  element={
                    <ResponsiveDrawer>
                      <AreaInfo />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/regioninfo"
                  element={
                    <ResponsiveDrawer>
                      <RegionInfo />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/stockdetials"
                  element={
                    <ResponsiveDrawer>
                      <StaffListingInfomation />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/manageadmins"
                  element={
                    <ResponsiveDrawer>
                      <ManageAdmins />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/createStock" //Change path to stock
                  element={
                    <ResponsiveDrawer>
                      <CreateListing />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/createEnquiry" //Change path to stock
                  element={
                    <ResponsiveDrawer>
                      <CreateEnquiry />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/manageLandlords" //Change path to stock
                  element={
                    <ResponsiveDrawer>
                      <ManageLandlords />{" "}
                    </ResponsiveDrawer>
                  }
                />
  <Route
                  path="/leadsNotifications" //Change path to stock
                  element={
                    <ResponsiveDrawer>
                      <LeadsNotifications />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/areamanagement"
                  element={
                    <ResponsiveDrawer>
                      <AreaManagement />{" "}
                    </ResponsiveDrawer>
                  }
                />
    
                <Route
                  path="/manageadmins"
                  element={
                    <ResponsiveDrawer>
                      <ManageAdmins />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/staff"
                  element={
                    <ResponsiveDrawer>
                      <AddStaffAdmin />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/publish"
                  element={
                    <ResponsiveDrawer>
                      <StaffPublishWizard />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/update"
                  element={
                    <ResponsiveDrawer>
                      <StaffUpdateWizard />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/updateEnquiry"
                  element={
                    <ResponsiveDrawer>
                      <StaffUpdateEnquiry />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/duplicateListing"
                  element={<ResponsiveDrawer>
                    <StaffDuplicateListing />{" "}
                  </ResponsiveDrawer>}/>
                <Route
                  path="/staffenquirydetails"
                  element={
                    <ResponsiveDrawer>
                      <StaffEnquiryInformation />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/adduseradmin"
                  element={
                    <ResponsiveDrawer>
                      <AddUserAdmin />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/staffcalendar"
                  element={
                    <ResponsiveDrawer>
                      <StaffPullForwardCalender />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/staffpullforward"
                  element={
                    <ResponsiveDrawer>
                      <StaffPullForward />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/staffpullforwardlisting"
                  element={
                    <ResponsiveDrawer>
                      <StaffPullForwardListing />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/addtenantadmin"
                  element={
                    <ResponsiveDrawer>
                      <AddTenantAdmin />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ResponsiveDrawer>
                      <StaffProfile />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/managerProfile"
                  element={
                    <ResponsiveDrawer>
                      <BrokerProfile />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/branches"
                  element={
                    <ResponsiveDrawer>
                      <CreateBranch />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/branchStats"
                  element={
                    <ResponsiveDrawer>
                      <BranchStatistics />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/branchInfo"
                  element={
                    <ResponsiveDrawer>
                      <BranchInformation />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/editprofile"
                  element={
                    <ResponsiveDrawer>
                      <StaffEditProfile />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/enquiries"
                  element={
                    <ResponsiveDrawer>
                      <StaffEnquiries />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ResponsiveDrawer>
                      <Dashboard />{" "}
                    </ResponsiveDrawer>
                  }
                />

                {/* Broker */}
                <Route
                  path="/brokerstock"
                  element={
                    <ResponsiveDrawer>
                      <BrokerListings />{" "}
                    </ResponsiveDrawer>
                  }
                />

                <Route
                  path="/addtenant"
                  element={
                    <ResponsiveDrawer>
                      <AddTenant />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/brokerprofile"
                  element={
                    <ResponsiveDrawer>
                      <BrokerProfile />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/editbrokerprofile"
                  element={
                    <ResponsiveDrawer>
                      <BrokerEditProfile />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/brokerenquiries"
                  element={
                    <ResponsiveDrawer>
                      <BrokerEnquiries />{" "}
                    </ResponsiveDrawer>
                  }
                />
                <Route
                  path="/brokerenquirydetails"
                  element={
                    <ResponsiveDrawer>
                      <BrokerEnquiryInformation />{" "}
                    </ResponsiveDrawer>
                  }
                />
                {/* General  */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                {features.WebsitePagesEnabled ? (
                  <Route path="/register" element={<RegisterPage />} />
                ) : null}
                {features.WebsitePagesEnabled ? (
                  <Route path="/login" element={<LoginPage />} />
                ) : null}
                {features.WebsitePagesEnabled ? (
                  <Route path="/" element={<LandingPage />} />
                ) : (
                  <Route path="/" element={<LoginPage />} />
                )}
              </Routes>
            </BrowserRouter>
          </AuthLoading>
        </FirebaseProvider>
      </Provider>
    </DndProvider>
  );
}

export default App;
